// extracted by mini-css-extract-plugin
export default {"root":"overall_duration-module___root___c614ef33"};